import { useCallback } from 'react';

/* eslint-disable @typescript-eslint/ban-types */
const actions = {
    init: 'init',
    setColumnOrder: 'setColumnOrder',
};
const reducer = (state, action, previousState) => {
    var _a;
    if (action.type === actions.setColumnOrder) {
        const columns = ((_a = previousState === null || previousState === void 0 ? void 0 : previousState.columnOrder) === null || _a === void 0 ? void 0 : _a.length) ? previousState === null || previousState === void 0 ? void 0 : previousState.columnOrder : action.columnNames;
        const { draggedColumnId, droppedColumnId, dragDirection } = action;
        const newColOrder = [...columns];
        const draggedIndex = columns.findIndex((id) => id === draggedColumnId);
        newColOrder.splice(draggedIndex, 1);
        let droppedIndex = newColOrder.findIndex(id => id === droppedColumnId);
        if (dragDirection === 'after') {
            droppedIndex += 1;
        }
        newColOrder.splice(droppedIndex, 0, draggedColumnId);
        return Object.assign(Object.assign({}, state), { columnOrder: newColOrder });
    }
};
const useInstance = (instance) => {
    const { dispatch, columns, state } = instance;
    const columnNames = columns.map(column => column.id);
    const onColumnDrop = useCallback((draggedColumnId, droppedColumnId, dragDirection) => {
        dispatch({
            type: actions.setColumnOrder,
            columnNames,
            draggedColumnId,
            droppedColumnId,
            dragDirection,
        });
    }, [columnNames, dispatch]);
    Object.assign(instance, {
        onColumnDrop,
        columnOrder: state.columnOrder.length === 0 ? columnNames : state.columnOrder,
    });
};
const useColumnDrag = (hooks) => {
    hooks.stateReducers.push(reducer);
    hooks.useInstance.push(useInstance);
};

export { actions, useColumnDrag as default };
//# sourceMappingURL=useColumnDrag.js.map
